import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useTranslation } from "react-i18next";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

export const ChannelClasssification = () => {

    const { t } = useTranslation("knowledge");

    const { pub: { isPrivate } } = useCardContext();

    return (isPrivate &&
        <MprcFeedTypography variant="classification" noWrap component="div">
            {t("Feed.Card.Common.PrivateText")}
        </MprcFeedTypography>
    );
};
